<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Button, EmbedVideo, Heading, Paragraph, Small, openModal,
    } from '@smatch/cassiopeia-web-components';

    // STYLING
    import 'tailwindcss/tailwind.css';

    // STORES
    import { SKIP } from '../../store';

    /* INTERNALS ------------------------------------------------------------------------------- */

    const skipFinancing = (): void => {
        $SKIP.hasFinancing = true;
        openModal('#onboarding');
    };

</script>

<div class = 's8-wrap'>

    <Heading size = 'md'>Discover smatch Financing</Heading>

    <EmbedVideo source = 'https://www.loom.com/embed/96e413ef0ec24a91880297f641b930c2' css = 'mb-5' />

    <Paragraph>
        Smatch extends tailored financing options to eligible buyers,
        providing flexible terms of 15, 30, 60, 90 or 120 days upfront.
    </Paragraph>

    <Paragraph>
        Unlock growth potential with advance financing, enabling you to
        swiftly capitalize on opportunities without tying up vital capital.
    </Paragraph>

    <Paragraph>
        Gain flexibility and competitive edge by accessing funds upfront,
        maximizing profitability while mitigating inventory risks.
    </Paragraph>

    <div class = 's8-footer'>

        <div>

            <Button
                type = 'button'
                label = 'Not Interested'
                color = 'neutral'
                css = 'w-full'
                on:click = { skipFinancing }
            />

        </div>

        <div>

            <Button
                type = 'submit'
                label = 'Check Eligibility'
                css = 'w-full'
                url = '#onboarding/financing-form'
            />

            <Small>(no commitment)</Small>

        </div>

    </div>

</div>


<style lang='postcss'>

    div.s8-wrap {

        :global(p) {
            margin-bottom: 20px;
        }

        div.s8-footer {
            display: flex;
            column-gap: 10px;
            flex-grow: 1;
            align-items: flex-end;
            margin-top: 40px;
            align-items: flex-start;

            > div {
                text-align: center;
                flex: 1;
            }
        }
    }

</style>